export default __webpack_public_path__ + "static/media/aniAlgoPic.ff193209.png";